import { Badge, type BadgeProps } from 'reactstrap';
import cls from 'classnames';
import './index.scss';

export const Dot: React.FC<BadgeProps> = ({ className = '', ...restProps }) => (
    <Badge
        className={cls(className, 'dot')}
        {...restProps}
    >
        &nbsp;
    </Badge>
);